import React from 'react'

import { IPartnershipPreferencesV7Data } from '@unionco/alaris-app-types'
import { StyledMarkDown } from 'components/MarkDown'
import { ModuleCard } from 'components'

interface IPartnershipPreferencesV7ModuleProps {
    data: IPartnershipPreferencesV7Data
}

export const PartnershipPreferencesV7Module: React.FC<
    IPartnershipPreferencesV7ModuleProps
> = ({ data: { items } }) => {
    if (!items) return <></>
    const title = 'Partnership Preferences V7' //TODO: get better title from Alaris
    return (
        <>
            <div className="u-text-left">
                <h5 className="u-self-start u-pb-6 u-text-left">{title}</h5>
                {items && (
                    <ModuleCard.Body
                        innerCardPadding={['u-px-8', 'u-py-6']}
                        key="PartnershipPreferencesV7"
                        useNewStyling={true}
                    >
                        <StyledMarkDown content={items.value} />
                    </ModuleCard.Body>
                )}
            </div>
        </>
    )
}

export default PartnershipPreferencesV7Module
